import { ApiConfig } from "./ConstantService";

export async function ValidateCampaign(token, campaign_id) {
  let url_path = "/validate_campaign";
  const resp = await fetch(ApiConfig.endpoint + url_path, {
    method: "POST",
    mode: "cors",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ campaign_id: campaign_id }),
  });
  let data = await resp.json();
  if (!resp.ok) throw new Error(data.message);
  return data;
}

export function GetCampaignStatus(startDate, endDate) {
  const start = new Date(startDate); // Convert start_date to Date object
  const end = new Date(endDate); // Convert end_date to Date object
  const currentTime = new Date();
  if (currentTime >= start && currentTime <= end) {
    return { status: "Live", color: "green" }; // Live status
  } else {
    return { status: "Ended", color: "red" }; // Ended status
  }
}

export function GenerateCampaignDeskUrl(campaignId, partnerId) {
  return `https://desk.thetradedesk.com/app/partner/${partnerId}/buy/campaign/${campaignId}/details`;
}
